/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Office_Logo_UploadInputs */

const cs_settings_office_logo_upload = /** @type {(inputs: Settings_Office_Logo_UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nahrát logo`)
};

const en_settings_office_logo_upload = /** @type {(inputs: Settings_Office_Logo_UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload logo`)
};

/**
* | output |
* | --- |
* | "Upload logo" |
*
* @param {Settings_Office_Logo_UploadInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_office_logo_upload = /** @type {((inputs?: Settings_Office_Logo_UploadInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Office_Logo_UploadInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_office_logo_upload(inputs)
	return cs_settings_office_logo_upload(inputs)
});